'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/locale-provider/style/index.js
// module id = 479
// module chunks = 1